async function getSortedCameras(): Promise<{deviceId:string}[]> {
    try {
        // 1. Запрашиваем доступ к камере (активируем разрешения)
        await navigator.mediaDevices.getUserMedia({video: true});

        // 2. Получаем список устройств
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = devices.filter(device =>
            device.kind === 'videoinput' && device.deviceId !== ''
        );

        if (videoDevices.length === 0) {
            console.warn('Камеры не найдены или доступ запрещён');
            return [];
        }

        // 3. Собираем информацию о камерах
        const camerasWithInfo = [];
        for (const device of videoDevices) {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: {
                        deviceId: device.deviceId,
                        width: {ideal: 1280},  // Оптимальные параметры для фокусировки
                        height: {ideal: 720}
                    }
                });

                const track = stream.getVideoTracks()[0];
                const capabilities = track.getCapabilities?.() || {};
                const settings = track.getSettings();

                // Определяем тип камеры (задняя/передняя)
                const isBackCamera = (
                    settings.facingMode === 'environment' ||
                    (device.label.toLowerCase().includes('back') && !device.label.toLowerCase().includes('front'))
                );

                // Проверяем поддержку автофокуса (если свойство есть в capabilities)
                const hasAutofocus = 'focusMode' in capabilities
                    ? capabilities.focusMode.includes('continuous') ||
                    capabilities.focusMode.includes('auto')
                    : false;

                camerasWithInfo.push({
                    deviceId: device.deviceId,
                    label: device.label || `Камера ${device.deviceId.slice(0, 5)}`,
                    isBackCamera,
                    hasAutofocus,
                    group: getCameraGroup(isBackCamera, hasAutofocus)
                });

                track.stop();
            } catch (err) {
                console.warn(`Ошибка при проверке камеры ${device.deviceId}:`, err);
            }
        }

        // 4. Сортируем камеры по приоритету
        return camerasWithInfo.sort((a, b) => a.group - b.group);

    } catch (error) {
        console.error('Ошибка при работе с камерами:', error);
        return [];
    }
}

// Группировка камер по приоритету
function getCameraGroup(isBackCamera, hasAutofocus) {
    if (isBackCamera && hasAutofocus) return 1;    // Лучший вариант
    if (isBackCamera) return 2;                   // Задняя без автофокуса
    if (hasAutofocus) return 3;                   // Передняя с автофокусом
    return 4;                                     // Худший вариант
}
export default getSortedCameras